import { render } from "./EditHarp.vue?vue&type=template&id=bc185bc6"
import script from "./EditHarp.vue?vue&type=script&lang=js"
export * from "./EditHarp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__